<template>
  <div>
    <h1>Access Control</h1>
  </div>
</template>
<script>
export default {
  name: "AccessControl",
  data() {
    return {};
  },
};
</script>